// Builder ↔ agent model setting (phase M, M4-2). BuilderView.jsx is a
// coverage-excluded shell, so its model logic lives here.
//
// The Builder holds ONE value for the agent's model — "Workspace default" or
// an encoded pin (see utils/agentModel) — never an auto-filled provider/model.
import {
  WORKSPACE_DEFAULT, choiceValue, decodeChoice, modelPatch, modelSettingOf,
} from "../../utils/agentModel";

/** The Builder's model value for a loaded agent (or a new one). */
export function builderChoiceFromAgent(agent) {
  return agent ? choiceValue(modelSettingOf(agent)) : WORKSPACE_DEFAULT;
}

/** {provider, model} for the parts of the Builder that still need them
 *  (ranked-fallback seed, tier defaults, AI-assist context); "" when following
 *  the workspace default. */
export function builderPinParts(llmChoice) {
  const pin = decodeChoice(llmChoice);
  return { provider: pin?.provider || "", model: pin?.model || "" };
}

/** The model keys of the flow_config.llm block the Builder saves. */
export function builderLlmModelFields(llmChoice) {
  return modelPatch(decodeChoice(llmChoice)).flow_config.llm;
}
